import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

const Root = styled('div')(({ theme }) => ({
  '& > .logo-icon': {
    transition: theme.transitions.create(['width', 'height'], {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
}));

function Logo() {
  return (
    <Root className="flex items-center">
      <Link to="/">
        <img className="logo-icon h-36" src="/assets/images/logo/allpass-logo.svg" alt="logo" />
      </Link>
    </Root>
  );
}

export default Logo;
